import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import FormattersStore from '../stores/Formatters';
import PropTypes from 'prop-types';

const styles = {
  grid: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  addOn: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginRight: 'xsmall',
    color: 'section',
    fontSize: 'small'
  }
};

const AddonInfo = ({ selectedAddons }) => {
  const { numberFormatter } = FormattersStore.getState();
  const { Block } = UX2.Element;

  if (selectedAddons.length === 0) return null;

  return (
    <Block style={ styles.grid }>
      { selectedAddons?.map(addOn => {
        return (
          <Block key={ addOn.id } style={ styles.addOn }>
            { numberFormatter.formatCurrency(+addOn.price) } | { addOn.title }
          </Block>
        );
      }) }
    </Block>
  );
};

AddonInfo.propTypes = {
  selectedAddons: PropTypes.array.isRequired
};

export default AddonInfo;
